import type { FunctionComponent, ReactNode } from 'react'

import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

export const RenderInWindow: FunctionComponent<{ children: ReactNode }> = ({
	children,
}) => {
	const [container, setContainer] = useState<HTMLDivElement | null>(null)
	const newWindow = useRef<WindowProxy | null>(null)

	useEffect(() => {
		setContainer(document.createElement('div'))
	}, [])

	useEffect(() => {
		if (container) {
			newWindow.current = window.open(
				'',
				'Demo MitId login',
				'width=600,height=400,left=200,top=200',
			)
			newWindow.current?.document.body.appendChild(container)

			const curWindow = newWindow.current

			return () => curWindow?.close()
		}
	}, [container])

	return container && createPortal(children, container)
}
